import { fromJS } from 'immutable';
import type { AnyAction } from 'redux';

import type { TypedMap } from 'utils/typed-map';

import { INIT, INIT_SUCCESS, INIT_FAILED } from './constants';

type MutableState = {
  loading: boolean;
  error: null | Error;
};

export type DonationPageState = TypedMap<MutableState>;

export const initialState = fromJS({
  loading: false,
  error: null,
}) as DonationPageState;

function volunteerPageReducer(
  state: DonationPageState = initialState,
  action: AnyAction
): DonationPageState {
  switch (action.type) {
    case INIT:
      return state.merge({ loading: true, error: null });

    case INIT_SUCCESS:
      return state.merge({ loading: false, error: null });

    case INIT_FAILED:
      return state.merge({ loading: false, error: action.error });

    default:
      return state;
  }
}

export default volunteerPageReducer;
